import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RequestVoidPage } from './request-void.page';

const routes: Routes = [
  {
    path: '',
    component: RequestVoidPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RequestVoidPageRoutingModule {}
